export const stripQuotedEmailHistory = (body = '') => {
    const normalized = String(body).replace(/\r\n/g, '\n').replace(/\u00a0/g, ' ');
    const lines = normalized.split('\n');
    const quoteMarkerPatterns = [
        /^On\s.+wrote:\s*$/i,
        /^On\s.+at\s.+wrote:\s*$/i,
        /^Le\s.+a écrit\s*:\s*$/i,
        /^Am\s.+schrieb\s.+:\s*$/i,
        /^El\s.+escribió:\s*$/i,
        /^Em\s.+escreveu:\s*$/i,
        /^-+\s*Original Message\s*-+$/i,
        /^-+\s*Forwarded message\s*-+$/i,
        /^Begin forwarded message:\s*$/i,
        /^_{5,}\s*$/,
        /^From:\s.+/i,
    ];

    const isOutlookHeaderBlock = (index) => {
        const nextLines = lines.slice(index, index + 8).map(line => line.trim().toLowerCase());
        const hasFrom = nextLines.some(line => line.startsWith('from:'));
        const hasSentOrDate = nextLines.some(line => line.startsWith('sent:') || line.startsWith('date:'));
        const hasTo = nextLines.some(line => line.startsWith('to:'));
        const hasSubject = nextLines.some(line => line.startsWith('subject:'));
        return hasFrom && (hasSentOrDate || hasTo || hasSubject);
    };

    const quoteLineIndex = lines.findIndex((line, index) => {
        const trimmed = line.trim();
        if (!trimmed) return false;
        if (trimmed.startsWith('>')) return true;
        if (/^From:\s.+/i.test(trimmed)) return isOutlookHeaderBlock(index);
        return quoteMarkerPatterns.some(pattern => pattern.test(trimmed));
    });

    const quoteLineCharIndex = quoteLineIndex >= 0
        ? lines.slice(0, quoteLineIndex).join('\n').length + (quoteLineIndex > 0 ? 1 : 0)
        : -1;
    const inlineQuotePatterns = [
        /\s+Sent from my iPhone\s+On\s(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec|\d{1,2}\/|\d{4}-\d{2}-\d{2}).{0,500}?wrote:/i,
        /\s+On\s(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec|\d{1,2}\/|\d{4}-\d{2}-\d{2}).{0,500}?wrote:/i,
    ];
    const inlineQuoteCharIndexes = inlineQuotePatterns
        .map(pattern => normalized.search(pattern))
        .filter(index => index >= 0);
    const quoteCharIndexes = [
        quoteLineCharIndex,
        ...inlineQuoteCharIndexes,
    ].filter(index => index >= 0);
    const quoteCharIndex = quoteCharIndexes.length > 0 ? Math.min(...quoteCharIndexes) : -1;

    return (quoteCharIndex >= 0 ? normalized.slice(0, quoteCharIndex) : normalized).trim();
};

export const getEmailEventContent = (event = {}) => {
    const notes = event.notes || '';
    const subjectFromNotes = notes.match(/^Subject:\s*(.*?)(?:\r?\n|$)/)?.[1] || '';
    const subject = event.subject || subjectFromNotes;
    const bodyWithQuotedHistory = subjectFromNotes ? notes.replace(/^Subject:[^\r\n]*(?:\r?\n){0,2}/, '') : notes;
    const body = stripQuotedEmailHistory(bodyWithQuotedHistory);
    return { subject, body };
};

export const isManualEmailNote = (event = {}) => {
    const notes = (event.notes || '').trim();
    return event.type === 'email_sent'
        && !event.recipient_email
        && !event.gmail_message_id
        && !event.subject
        && !notes.startsWith('Subject:');
};
